import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase"; // تأكد من المسار الصحيح

function DashboardHome() {
  const [stats, setStats] = useState({
    products: 0,
    orders: 0,
    sales: 0,
  });

  useEffect(() => {
   const fetchStats = async () => {
  try {
    const productsSnap = await getDocs(collection(db, "products"));
    const ordersSnap = await getDocs(collection(db, "orders"));

    const totalSales = ordersSnap.docs.reduce((sum, doc) => {
      const order = doc.data();
      const orderTotal = order.items?.reduce((s, item) => s + (item.price || 0), 0) || 0;
      return sum + orderTotal;
    }, 0);

    setStats({
      products: productsSnap.size,
      orders: ordersSnap.size,
      sales: totalSales,
    });
  } catch (error) {
    console.error("Error fetching stats:", error);
  }
};

    fetchStats();
  }, []);

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>📊 إحصائيات عامة</h2>
      <div style={styles.cardsContainer}>
        <div style={{ ...styles.card, backgroundColor: "#4e73df" }}>
          <h3>عدد المنتجات</h3>
          <p style={styles.number}>{stats.products}</p>
        </div>
        <div style={{ ...styles.card, backgroundColor: "#1cc88a" }}>
          <h3>عدد الطلبات</h3>
          <p style={styles.number}>{stats.orders}</p>
        </div>
        <div style={{ ...styles.card, backgroundColor: "#36b9cc" }}>
          <h3>إجمالي المبيعات</h3>
          <p style={styles.number}>{stats.sales} ج.م</p>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    padding: "20px",
  },
  title: {
    marginBottom: "30px",
  },
  cardsContainer: {
    display: "flex",
    gap: "20px",
    flexWrap: "wrap",
  },
  card: {
    flex: "1 1 250px",
    color: "#fff",
    padding: "20px",
    borderRadius: "10px",
    textAlign: "center",
    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
  },
  number: {
    fontSize: "28px",
    fontWeight: "bold",
    marginTop: "10px",
  },
};

export default DashboardHome;
